import axios from "axios";

const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_CONSUMER_PORTAL_API_KEY: CONSUMER_PORTAL_API_KEY,
} = process.env;

export const axiosAWSConsumer = axios.create({
  baseURL: API_URL,
  headers: {
    "API-KEY": CONSUMER_PORTAL_API_KEY,
  },
});

export const axiosAWSPortalConsumer = axios.create({
  baseURL: "https://api.myprotectall.com/consumer_portal",
  headers: {
    "X-API-KEY": "T4x8ndqQXi7SQS2qut58a8iF5SyNO1P381HqLWK4",
  },
});
